export default {
  paged: {
    select:
      'id,name,isActive,fileName,size,fileTypeClassification,ownerType,contentType,eTag,created,updated,ownerDisplay,ownerId',
    searchSelect: ['name', 'fileName'],
    orderBy: 'name',
    expand: {
      category: { select: 'id,name' },
    },
  },
  item: {
    select:
      'id,name,isActive,fileName,size,fileTypeClassification,contentType,tags,documentUrl,eTag,ownerType,ownerId,ownerDisplay',
    expand: {
      category: { select: 'id,name' },
    },
  },
  itemDetail: {
    expand: {
      category: { select: 'id,name' },
    },
  },
};
